/*
 * KFA minimum bestelwaarde (CEO 12-10-2026).
 *
 * Verzending begint in Shopify pas bij een mandje van 20 euro. Dit script laat dat de klant vooraf weten:
 *  - <kfa-minimum-order> (winkelmandje, zijpaneel, "toegevoegd"-paneel): melding met het bedrag dat nog ontbreekt,
 *    en de kassaknoppen in hetzelfde paneel gaan uit tot de 20 euro bereikt is.
 *  - <kfa-minimum-note> (productpagina): korte regel en geen "direct kopen"-knop, maar alleen bij producten waarvan
 *    elke variant onder de 20 euro zit.
 *
 * Faalt altijd open: bij elke fout blijven de knoppen gewoon werken, zoals voorheen.
 * Drempel in winkelvaluta (centen), omgerekend met Shopify.currency.rate, net als de gratis-verzendingbalk van het thema.
 */
(function () {
  if (window.KFA_MINIMUM_ORDER_LOADED) return;
  window.KFA_MINIMUM_ORDER_LOADED = true;

  function koers() {
    try {
      var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return r > 0 ? r : 1;
    } catch (e) {
      return 1;
    }
  }

  // In euro exact; in een andere munt 1% marge, zodat afronding nooit een geldige bestelling tegenhoudt.
  function onderMinimum(totaal, drempel) {
    return koers() === 1 ? totaal < drempel : totaal < drempel * 0.99;
  }

  function bedrag(centen) {
    try {
      var heel = centen % 100 === 0;
      return new Intl.NumberFormat(window.Shopify.locale, {
        style: "currency",
        currency: window.Shopify.currency.active,
        minimumFractionDigits: heel ? 0 : 2,
        maximumFractionDigits: heel ? 0 : 2
      }).format(centen / 100);
    } catch (e) {
      return (centen / 100).toFixed(2);
    }
  }

  // Weergave: in euro exact (20 €, 13,05 €); in een andere munt naar boven afgerond op hele eenheden (SEK 229).
  function weergave(centen) {
    return koers() === 1 ? centen : Math.ceil(centen / 100) * 100;
  }

  function vul(sjabloon, waarden) {
    return String(sjabloon || "").replace(/{{\s*(\w+)\s*}}/g, function (geheel, sleutel) {
      return Object.prototype.hasOwnProperty.call(waarden, sleutel) ? waarden[sleutel] : geheel;
    });
  }

  function drempelInMunt(element) {
    return Math.round(parseFloat(element.getAttribute("threshold")) * koers());
  }

  class KfaMinimumOrder extends HTMLElement {
    connectedCallback() {
      this._uitgezet = [];
      this._opWijziging = this._opWijziging.bind(this);
      document.addEventListener("cart:change", this._opWijziging);
      this.bijwerken();
    }

    disconnectedCallback() {
      document.removeEventListener("cart:change", this._opWijziging);
      this.vrijgeven();
    }

    get bereik() {
      return this.closest("cart-drawer, .quick-buy-drawer__info, .shopify-section") || this.parentElement || document;
    }

    _opWijziging(event) {
      try {
        var cart = event && event.detail && event.detail.cart;
        if (!cart || !cart.items) return;
        var artikelen = cart.items
          .filter(function (regel) { return regel.requires_shipping; })
          .reduce(function (som, regel) { return som + regel.final_line_price; }, 0);
        var korting = (cart.cart_level_discount_applications || [])
          .reduce(function (som, k) { return som + k.total_allocated_amount; }, 0);
        this.setAttribute("total-price", String(artikelen - korting));
        this.bijwerken();
      } catch (e) {
        this.hidden = true;
        this.vrijgeven();
      }
    }

    vrijgeven() {
      try {
        (this._uitgezet || []).forEach(function (knop) {
          knop.disabled = false;
          knop.removeAttribute("aria-disabled");
          knop.classList.remove("kfa-min-uit");
        });
      } catch (e) {}
      this._uitgezet = [];
    }

    bijwerken() {
      try {
        var drempel = drempelInMunt(this);
        var totaal = parseFloat(this.getAttribute("total-price"));
        if (!(drempel > 0) || !(totaal > 0) || !onderMinimum(totaal, drempel)) {
          this.hidden = true;
          this.vrijgeven();
          return;
        }
        var doel = this.querySelector("[data-kfa-min-tekst]") || this;
        doel.innerHTML = vul(this.getAttribute("message"), {
          remaining_amount: '<span class="bold">' + bedrag(weergave(drempel - totaal)) + "</span>",
          minimum_amount: bedrag(weergave(drempel))
        });
        this.hidden = false;
        var zelf = this;
        this.bereik.querySelectorAll('button[name="checkout"]').forEach(function (knop) {
          if (!knop.disabled) {
            knop.disabled = true;
            knop.setAttribute("aria-disabled", "true");
            knop.classList.add("kfa-min-uit");
            zelf._uitgezet.push(knop);
          }
        });
      } catch (e) {
        this.hidden = true;
        this.vrijgeven();
      }
    }
  }

  class KfaMinimumNote extends HTMLElement {
    connectedCallback() {
      this.bijwerken();
    }

    disconnectedCallback() {
      this.herstel();
    }

    herstel() {
      try {
        if (this._verborgen) this._verborgen.style.display = "";
      } catch (e) {}
      this._verborgen = null;
    }

    bijwerken() {
      try {
        var drempel = drempelInMunt(this);
        var stuk = parseFloat(this.getAttribute("unit-price"));
        var hoogste = parseFloat(this.getAttribute("price-max"));
        // Alleen voor producten waarvan elke variant onder het minimum zit; anders niets aanraken.
        if (!(drempel > 0) || !(stuk > 0) || !(hoogste > 0) || !onderMinimum(hoogste, drempel) || !onderMinimum(stuk, drempel)) {
          this.hidden = true;
          this.herstel();
          return;
        }
        var doel = this.querySelector("[data-kfa-min-tekst]") || this;
        doel.innerHTML = vul(this.getAttribute("message"), { minimum_amount: bedrag(weergave(drempel)) });
        this.hidden = false;
        var formulier = document.getElementById(this.getAttribute("form-id"));
        var knop = formulier ? formulier.querySelector(".shopify-payment-button") : null;
        if (knop) {
          knop.style.display = "none";
          this._verborgen = knop;
        }
      } catch (e) {
        this.hidden = true;
        this.herstel();
      }
    }
  }

  if (!window.customElements.get("kfa-minimum-order")) {
    window.customElements.define("kfa-minimum-order", KfaMinimumOrder);
  }
  if (!window.customElements.get("kfa-minimum-note")) {
    window.customElements.define("kfa-minimum-note", KfaMinimumNote);
  }
})();
